﻿import {Delegate} from "../Tools/Delegate.js";

export const OnClientDelete = new Delegate();
export const OnClientAdd = new Delegate();
export const OnClientUpdate = new Delegate();
